import React from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import { strings } from '../../resources/strings';
import ServicesContext from '../../contexts/ServicesContext';
import { HistoryByOrder } from '../../services/Orders/GetHistoryByOrder/HistoryByOrder';
import { Card, Title, CreatedAt, CreatedBy, LeftContainer, RightContainer, Details } from './styles';

interface IModalHistoryProps {
    visible: boolean;
    close: (orderId?: number) => void;
    title: string;
    orderId?: number;
}

const ModalHistory: React.FC<IModalHistoryProps> = ({
    visible,
    close,
    title,
    orderId
}) => {

    const [ history, setHistory ] = React.useState<HistoryByOrder[]>([]);

    const {
        getHistoryByOrderService,
        toastService
    } = React.useContext(ServicesContext);

    React.useEffect(() => {
        if (!visible) return;
        getHistoric();
    }, [ visible ]);

    const body = React.useMemo(() => {
        return history.map((item, index) => {
            return (
                <Card key={`item-${index}`} borderTop={index > 0}>
                    <LeftContainer>
                        <Title>{item.stateDescription}</Title>
                        {item.details ? <Details>{item.details}</Details> : null}
                    </LeftContainer>
                    <RightContainer>
                        <CreatedAt>{moment(item.createdAt).format('DD/MM/yyyy HH:mm:ss')}</CreatedAt>
                        <CreatedBy>{item.userName}</CreatedBy>
                    </RightContainer>
                </Card>
            )
        });
    }, [ history ]);

    if (!visible) return null;

    return (
        <Modal
            show={visible}
            onHide={() => clickCloseModal()}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body id='modalRecipeBody' style={{maxHeight:'78vh',overflowY:'auto'}}>
                {body}
            </Modal.Body>
        </Modal>
    );

    function getHistoric() {
        if (!orderId) return;
        getHistoryByOrderService
            .handle({orderId: orderId}).then(result => {
                setHistory(result?.value?.history || []);
            })
            .catch(() => {
                toastService.warning(strings.OpsSomethingWrongGettingTheData);
            });
    }

    function clickCloseModal() {
        close(orderId);
    }
}

export {ModalHistory};